"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmTooltip = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.SmTooltip = (0, react_1.forwardRef)((_a, ref) => {
    var { id, text, position = 'top', children, className } = _a, props = __rest(_a, ["id", "text", "position", "children", "className"]);
    const [isOpen, setOpen] = (0, react_1.useState)(false);
    const [isActive, setActive] = (0, react_1.useState)(false);
    const [bounding, setBounding] = (0, react_1.useState)(undefined);
    const innerRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => innerRef.current);
    react_1.default.useEffect(() => {
        var _a;
        setBounding((_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect());
    }, []);
    const responsivePosition = react_1.default.useMemo(() => {
        if (bounding) {
            if (bounding.top <= 0) {
                return 'bottom';
            }
            if (bounding.bottom >=
                (window.innerHeight || document.documentElement.clientHeight)) {
                return 'top';
            }
            if (bounding.left <= 0) {
                return 'right';
            }
            if (bounding.right >=
                (window.innerWidth || document.documentElement.clientWidth)) {
                return 'left';
            }
        }
        return position;
    }, [position, bounding]);
    const tooltipClassname = (0, classnames_1.default)('c-tooltip', className);
    const tooltipTextClassname = (0, classnames_1.default)('c-tooltip__text', `-${responsivePosition}`, { '-opened': isOpen }, { '-active': isActive });
    const childProps = react_1.default.useCallback((element) => {
        return {
            'aria-describedby': id,
            tabIndex: 0,
            onMouseOver: (e) => {
                var _a, _b;
                setOpen(true);
                (_b = element === null || element === void 0 ? void 0 : (_a = element.props).onMouseOver) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            },
            onMouseLeave: (e) => {
                var _a, _b;
                setOpen(false);
                (_b = element === null || element === void 0 ? void 0 : (_a = element.props).onMouseLeave) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            },
            onFocus: (e) => {
                var _a, _b;
                setOpen(true);
                (_b = element === null || element === void 0 ? void 0 : (_a = element.props).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            },
            onBlur: (e) => {
                var _a, _b;
                setOpen(false);
                setActive(false);
                (_b = element === null || element === void 0 ? void 0 : (_a = element.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            },
            onClick: (e) => {
                var _a, _b;
                setActive(!isActive);
                (_b = element === null || element === void 0 ? void 0 : (_a = element.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            },
        };
    }, []);
    const adaptedChidlren = (0, react_1.useMemo)(() => {
        return react_1.default.Children.map(children, (child) => {
            if (typeof child === 'string') {
                return react_1.default.cloneElement(react_1.default.createElement("span", null), childProps(), child);
            }
            return react_1.default.cloneElement(child, childProps(child));
        });
    }, [childProps]);
    return (react_1.default.createElement("span", Object.assign({}, props, { className: tooltipClassname, role: "tooltip", tabIndex: -1 }),
        adaptedChidlren,
        react_1.default.createElement("span", { id: id, ref: innerRef, className: tooltipTextClassname }, text)));
});
//# sourceMappingURL=index.js.map